export default {
  title: "Lista de Invitados",
  description: "Gestiona tu lista de invitados y sus invitaciones",
  addGuest: "Añadir Invitado",
  editGuest: "Editar Invitado",
  noGuests: "Sin invitados aún",
  addFirstGuest: "Añade tu primer invitado para comenzar",
  children: "Niños",
  teens: "Adolescentes",
  search: "Buscar un invitado",
  cancel: "Cancelar",
  guests: {
    statusLabels: {
      pending: "Pendiente",
      confirmed: "Confirmado",
      declined: "Rechazado",
      invited: "Invitado",
      maybe: "Tal vez",
      not_invited: "No invitado"
    }
  },
  import: {
    title: "Importar Invitados",
    instructions: "Descarga la plantilla y la documentación para entender el formato de importación. Una vez que tu archivo esté listo, selecciónalo para importarlo.",
    downloadTemplate: "Descargar Plantilla",
    downloadExcelTemplate: "Descargar Plantilla Excel",
    downloadCsvTemplate: "Descargar Plantilla CSV",
    downloadDocumentation: "Descargar Documentación",
    selectFile: "Seleccionar Archivo",
    importButton: "Importar",
    preview: {
      summary: "{{valid}} líneas válidas de {{total}} ({{errors}} errores)",
      toggleDetails: "Ver detalles de errores",
      rowNumber: "Línea {{row}}",
      retry: "Reintentar con otro archivo"
    },
    errors: {
      title: "Error de Importación",
      invalidFileType: "El archivo debe estar en formato CSV o Excel",
      parseError: "Error al leer el archivo",
      excelParseError: "Error al leer el archivo Excel",
      fileReadError: "Error al leer el archivo",
      importFailed: "La importación falló",
      noValidGuests: "No se encontraron invitados válidos en el archivo",
      validationErrors: "Se encontraron {{count}} error(es) de validación:{{details}}",
      missingHeaders: "Faltan columnas requeridas: {{headers}}",
      missingFirstName: "El nombre es obligatorio",
      missingLastName: "El apellido es obligatorio",
      invalidStatus: "Estado inválido: {{status}}",
      invalidCategory: "Categoría inválida: {{category}}",
      invalidSide: "Lado inválido: {{side}}",
      invalidRelation: "Relación inválida: {{relation}}",
      invalidAgeGroup: "Grupo de edad inválido: {{ageGroup}}",
      invalidVip: "El valor VIP debe ser 'true' o 'false'",
      invalidPlusOne: "El valor +1 debe ser 'true' o 'false'",
      invalidChildrenCount: "El número de niños debe ser un número entero",
      invalidTeenCount: "El número de adolescentes debe ser un número entero",
      missingPlusOneInfo: "La información del +1 está incompleta",
      invalidEmail: "La dirección de email no es válida"
    },
    description: "Importe su lista de invitados desde un archivo CSV",
    template: "Descargar plantilla",
    upload: "Subir archivo",
    processing: "Procesando...",
    success: "{{count}} invitados importados con éxito",
    error: "Error al importar invitados",
    formatError: "Formato de archivo no válido"
  },
  pagination: {
    showing: "Mostrando {{from}} a {{to}} de {{total}} invitados",
    previous: "Anterior",
    next: "Siguiente"
  },
  columns: {
    name: "Nombre",
    email: "Email",
    category: "Categoría",
    table: "Mesa",
    status: "Estado",
    children: "Niños",
    actions: "Acciones",
    plusOne: "Acompañante",
    phone: "Teléfono",
    group: "Grupo"
  },
  table: {
    name: "Nombre",
    email: "Email",
    phone: "Teléfono",
    status: "Estado",
    relation: "Relación",
    side: "Lado",
    children: "Niños",
    actions: "Acciones",
    headers: {
      name: "Nombre",
      email: "Email",
      group: "Grupo",
      events: "Eventos",
      plusOne: "+1",
      status: "Estado",
      actions: "Acciones"
    },
    noEmail: "Sin Email",
    noData: "-"
  },
  filters: {
    title: "Filtros",
    reset: "Restablecer",
    resetFilters: "Restablecer Filtros",
    status: {
      label: "Estado",
      all: "Todos",
      confirmed: "Confirmado",
      pending: "Pendiente",
      declined: "Rechazado"
    },
    group: {
      label: "Grupo",
      all: "Todos",
      family: "Familia",
      friends: "Amigos",
      colleagues: "Colegas",
      other: "Otro"
    },
    statusOptions: {
      all: "Todos",
      confirmed: "Confirmado",
      pending: "Pendiente",
      declined: "Rechazado"
    },
    events: {
      label: "Eventos",
      all: "Todos",
      ceremony: "Ceremonia",
      reception: "Recepción",
      both: "Ambos",
      allEvents: "Todos los Eventos"
    },
    relation: "Relación",
    side: "Lado",
    ageGroup: "Grupo de Edad",
    clear: "Limpiar Filtros",
    apply: "Aplicar",
    guestsearch: "Buscar un invitado",
    previous: "Anterior",
    next: "Siguiente",
    tableAssigned: "Mesa Asignada",
    category: "Categoría",
    table: "Mesa",
    all: "Todos"
  },
  sharing: {
    share: "Compartir",
    title: "Compartir Invitados",
    defaultMessage: "He compartido invitados contigo",
    recipientEmail: "Email del Destinatario",
    emailPlaceholder: "Ingresa el email del destinatario",
    recipientName: "Nombre del Destinatario",
    namePlaceholder: "Ingresa el nombre del destinatario",
    message: "Mensaje",
    messagePlaceholder: "Ingresa tu mensaje",
    accessLevel: "Nivel de Acceso",
    readOnly: "Solo Lectura",
    edit: "Editar",
    success: "Invitación enviada con éxito"
  },
  status: {
    "guests.status.pending": "Pendiente",
    pending: "Pendiente",
    confirmed: "Confirmado",
    declined: "Rechazado",
    maybe: "Tal vez",
    invited: "Invitado",
    notInvited: "No Invitado",
    tentative: "Tentativo"
  },
  relation: {
    family: "Familia",
    friend: "Amigo",
    colleague: "Colega",
    other: "Otro",
    parent: "Padre/Madre",
    sibling: "Hermano/Hermana",
    cousin: "Primo/Prima",
    uncleAunt: "Tío/Tía",
    grandparent: "Abuelo/Abuela"
  },
  side: {
    hostA: "Anfitrión A",
    hostB: "Anfitrión B",
    both: "Ambos",
    none: "Ninguno",
    bride: "Novia",
    groom: "Novio"
  },
  ageGroup: "Grupo de edad",
  form: {
    title: "Detalles del Invitado",
    firstName: "Nombre",
    lastName: "Apellido",
    email: "Email",
    phone: "Teléfono",
    status: "Estado",
    relation: "Relación",
    side: "Lado",
    ageGroup: "Grupo de Edad",
    dietaryRestrictions: "Restricciones Dietéticas",
    specialRequirements: "Necesidades Especiales",
    plusOne: "Acompañante",
    children: "Niños",
    submit: "Guardar",
    cancel: "Cancelar",
    address: "Dirección",
    category: "Categoría",
    notes: "Notas",
    table: "Mesa",
    errors: {
      firstNameRequired: "El nombre es obligatorio",
      lastNameRequired: "El apellido es obligatorio",
      emailInvalid: "Dirección de correo electrónico no válida"
    }
  },
  actions: {
    addGuest: "Añadir Invitado",
    editGuest: "Editar Invitado",
    deleteGuest: "Eliminar Invitado",
    importGuests: "Importar Invitados",
    exportGuests: "Exportar Invitados",
    sendInvitation: "Enviar Invitación",
    resendInvitation: "Reenviar Invitación",
    import: "Importar",
    export: "Exportar",
    search: "Buscar...",
    sendReminder: "Enviar Recordatorio",
    edit: "Editar",
    delete: "Eliminar",
    createInvitation: "Crear Invitación",
    cancel: "Cancelar",
    save: "Guardar",
    view: "Ver",
    filter: "Filtrar"
  },
  messages: {
    guestAdded: "Invitado añadido exitosamente",
    guestUpdated: "Invitado actualizado exitosamente",
    guestDeleted: "Invitado eliminado exitosamente",
    guestsImported: "Invitados importados exitosamente",
    guestsExported: "Invitados exportados exitosamente",
    invitationSent: "Invitación enviada exitosamente",
    noGuests: "Sin invitados",
    addFirstGuest: "Añade tu primer invitado",
    createSuccess: "Invitado añadido exitosamente",
    updateSuccess: "Invitado actualizado exitosamente",
    deleteSuccess: "Invitado eliminado exitosamente",
    deleteConfirm: "¿Estás seguro de que quieres eliminar este invitado?",
    error: "Ha ocurrido un error",
    reminderSent: "Recordatorio enviado exitosamente",
    importSuccess: "Importación completada exitosamente",
    exportSuccess: "Exportación completada exitosamente"
  },
  modal: {
    title: "Invitado",
    guestDetails: "Detalles del Invitado",
    firstName: "Nombre",
    lastName: "Apellido",
    email: "Email",
    phone: "Teléfono",
    status: "Estado",
    category: "Categoría",
    side: "Lado",
    ageGroup: "Grupo de Edad",
    plusOne: "Acompañante",
    plusOneFirstName: "Nombre del Acompañante",
    plusOneLastName: "Apellido del Acompañante",
    dietaryRestrictions: "Restricciones Dietéticas",
    dietaryRestrictionsPlaceholder: "Vegetariano, alergias, intolerancia al gluten...",
    notes: "Notas",
    childrenCount: "Número de niños (0-12 años)",
    teenCount: "Número de adolescentes (13-17 años)",
    personalInfo: "Información Personal",
    accompaniment: "Acompañante y Niños",
    children: "Niños",
    relation: "Relación",
    attendance: "Asistencia",
    confirmDelete: "¿Estás seguro de que quieres eliminar este invitado?",
    categoryOptions: {
      bride_groom: "Novios",
      family_close: "Familia Cercana",
      family_extended: "Familia Extendida",
      witness: "Testigo",
      honor_party: "Cortejo",
      friend_close: "Amigo Cercano",
      friend: "Amigo",
      colleague: "Colega",
      acquaintance: "Conocido",
      other: "Otro"
    },
    relationOptions: {
      parent: "Padre/Madre",
      sibling: "Hermano/Hermana",
      cousin: "Primo/Prima",
      friend: "Amigo",
      colleague: "Colega",
      other: "Otro"
    },
    sideOptions: {
      bride: "Novia",
      groom: "Novio",
      both: "Ambos",
      none: "Ninguno"
    },
    statusOptions: {
      pending: "Pendiente",
      confirmed: "Confirmado",
      declined: "Rechazado"
    },
    ageGroupOptions: {
      adult: "Adulto",
      senior: "Mayor",
      ageRange: {
        adult: "(18-64 años)",
        senior: "(65+ años)"
      }
    },
    confirm: "Confirmar",
    decline: "Rechazar",
    specialRequirements: "Necesidades especiales",
    specialNeeds: "Necesidades específicas",
    specialNeedsPlaceholder: "Accesibilidad, necesidades particulares...",
    seatingPlanParams: "Configuración del plano de asientos",
    selectCategory: "Selecciona una categoría",
    selectRelation: "Seleccionar una relación",
    selectSide: "Seleccionar un lado",
    selectAgeGroup: "Seleccionar un grupo de edad",
    noEmail: "Sin correo",
    close: "Cerrar",
    successDescription: "Compartido con éxito",
    error: "Error",
    tableAssigned: "Mesa {{number}}",
    unnamed: "Sin nombre",
    vip: "VIP"
  },
  seatingPlan: {
    title: "Plan de Mesa",
    configTitle: "Configuración del Plan de Mesa",
    venueCapacity: "Capacidad del Lugar",
    guestStats: "Estadísticas de Invitados",
    tableCapacities: "Capacidades de Mesa",
    totalCapacity: "Capacidad Total",
    remainingSeats: "Asientos Restantes",
    placementOptions: "Opciones de Ubicación",
    avoidConflicts: "Evitar Conflictos",
    prioritizeHarmonies: "Priorizar Armonías",
    keepFamiliesTogether: "Mantener Familias Juntas",
    balanceAgeGroups: "Equilibrar Grupos de Edad",
    specialTables: "Mesas Especiales",
    childrenTableCapacity: "Capacidad de Mesa de Niños",
    teenTableCapacity: "Capacidad de Mesa de Adolescentes",
    config: "Configuración del Plan de Mesa",
    stats: "Estadísticas",
    totalGuests: "Total Invitados",
    children: "Niños",
    teens: "Adolescentes",
    tables: "Mesas",
    unassigned: "Sin Asignar",
    honorTable: "Mesa de Honor",
    table: "Mesa {{number}}",
    honorTableCapacity: "Capacidad de Mesa de Honor",
    standardTableCapacity: "Capacidad de Mesas Estándar",
    numberOfTables: "Número de Mesas",
    honorTableSide: "Lado de Mesa de Honor",
    options: "Opciones",
    prioritizeFamily: "Priorizar Familia",
    keepGroupsTogether: "Mantener Grupos Juntos",
    balanceTables: "Equilibrar Mesas",
    separateConflicts: "Separar Conflictos",
    generate: "Generar Plan",
    save: "Guardar",
    load: "Cargar Plan",
    loadSaved: "Planes Guardados",
    capacity: "capacidad",
    backToConfig: "Volver a la Configuración",
    separateFamilies: "Separar Familias",
    mixSidesForSingles: "Mezclar Lados para Solteros",
    separateFamiliesDesc: "Intenta colocar parejas de familias diferentes en mesas separadas",
    mixSidesForSinglesDesc: "Favorece la mezcla de lados (novia/novio) para invitados solteros",
    balanceTablesDesc: "Equilibra el número de invitados por mesa",
    statsDetails: {
      totalTables: "Número de Mesas",
      confirmedGuests: "Invitados Confirmados",
      averagePerTable: "Promedio por Mesa"
    },
    standardTables: "Mesas Estándar",
    places: "lugares",
    placesEach: "lugares cada una",
    childrenTable: "mesa niños",
    teenTable: "mesa adolescentes",
    generateSuccess: "Plan de mesa generado exitosamente",
    saveSuccess: "Plan de mesa guardado exitosamente",
    generateError: "Error generando plan de mesa",
    saveError: "Error guardando plan de mesa",
    emptyTable: "Mesa Vacía",
    noTables: "No se crearon mesas",
    noGuests: "No hay invitados para colocar",
    dragAndDrop: "Arrastra y suelta para modificar la ubicación",
    honorTableTooltip: "Mesa reservada para novios, testigos y familia cercana",
    childrenTableTooltip: "Mesa reservada para niños de 0 a 12 años",
    teenTableTooltip: "Mesa reservada para adolescentes de 13 a 17 años",
    capacityTooltip: "Número de asientos en esta mesa",
    editTable: "Editar Mesa",
    deleteTable: "Eliminar Mesa",
    addTable: "Añadir Mesa",
    moveGuest: "Mover Invitado",
    filterByTable: "Filtrar por Mesa",
    filterByStatus: "Filtrar por Estado",
    showUnassigned: "Mostrar Invitados Sin Asignar",
    export: "Exportar Plan",
    print: "Imprimir Plan",
    downloadPDF: "Descargar PDF",
    confirmDelete: "¿Estás seguro de que quieres eliminar esta mesa?",
    confirmReset: "¿Estás seguro de que quieres reiniciar el plan de mesa?",
    tableSaved: "Mesa guardada exitosamente",
    tableDeleted: "Mesa eliminada exitosamente",
    guestMoved: "Invitado movido exitosamente",
    errors: {
      honorTableTooSmall: "La mesa de honor ({{capacity}} asientos) es muy pequeña para acomodar a todos los VIP ({{required}} personas)",
      insufficientCapacity: "Capacidad total insuficiente ({{capacity}} asientos) para {{guests}} invitados"
    },
    autoTableCount: "Número estimado de mesas: {{tables}}",
    generationSummary: "Plan generado con {{tables}} mesas para {{guests}} invitados (capacidad total: {{capacity}} asientos)",
    guestDistribution: "Distribución por Categoría",
    sideDistribution: "Distribución por Lado",
    statusDistribution: "Distribución por Estado",
    ageDistribution: "Distribución por Edad",
    total: "Total",
    confirmedGuests: "Invitados Confirmados",
    honorTableHelp: "Número de asientos en la mesa de honor (novios, padres, testigos)",
    standardTableHelp: "Número de asientos en las mesas estándar",
    honorTableSideHelp: "Lado a priorizar para la mesa de honor",
    prioritizeFamilyHelp: "Coloca a la familia cercana en la mesa de honor primero",
    keepGroupsTogetherHelp: "Intenta mantener los grupos de invitados en la misma mesa",
    balanceTablesHelp: "Equilibra el número de invitados y su distribución en cada mesa",
    separateConflictsHelp: "Evita colocar invitados en conflicto en la misma mesa",
    planName: "Nombre del Plan",
    editPlanName: "Editar Nombre",
    planNamePlaceholder: "Nombre del plan de mesa",
    savedSuccessfully: "Plan de mesa guardado exitosamente",
    loadExisting: "Cargar Plan Existente",
    both: "Ambos",
    bride: "Novia",
    groom: "Novio"
  },
  errors: {
    loadWedding: "Error cargando datos de la boda",
    loadGuests: "Error cargando invitados",
    noWeddingFound: "No se encontró boda",
    generateSeatingPlan: "Error generando plan de mesa",
    saveSeatingPlan: "Error guardando plan de mesa",
    addGuest: "Error añadiendo invitado",
    updateGuest: "Error actualizando invitado",
    deleteGuest: "Error eliminando invitado",
    sendReminder: "Error enviando recordatorio",
    import: "Error durante la importación",
    export: "Error durante la exportación"
  },
  fields: {
    firstName: "Nombre",
    lastName: "Apellido",
    status: "Estado",
    category: "Categoría",
    relation: "Relación",
    side: "Lado"
  },
  category: {
    family: "Familia",
    friend: "Amigo",
    colleague: "Colega",
    other: "Otro"
  },
  guestsWidget: {
    title: "Invitados",
    subtitle: "Gestiona tus invitados",
    total: "Total",
    confirmed: "Confirmados",
    pending: "Pendientes",
    declined: "Rechazados",
    manage: "Gestionar Invitados",
    empty: "Sin Invitados",
    addGuest: "Añadir Invitado"
  },
  validation: {
    required: {
      lastName: "El apellido es obligatorio",
      firstName: "El nombre es obligatorio"
    },
    invalid: {
      email: "Email inválido"
    }
  },
  bulkActions: {
    selectMultiple: "Selección Múltiple",
    exitSelection: "Salir de la Selección",
    selectedCount: "{{count}} invitado(s) seleccionado(s)",
    selectAll: "Seleccionar Todo",
    deselectAll: "Deseleccionar Todo",
    markConfirmed: "Marcar Confirmado",
    markPending: "Marcar Pendiente",
    markDeclined: "Marcar Rechazado",
    confirmStatusUpdate: "Confirmar Cambio de Estado",
    confirmStatusUpdateMessage: "¿Estás seguro de que quieres cambiar el estado de {{count}} invitado(s) a \"{{status}}\"?",
    statusUpdateSuccess: "Estado actualizado para {{count}} invitado(s)",
    statusUpdateError: "Error actualizando estado",
    selected: "Seleccionado",
    selectThis: "Seleccionar este invitado"
  },
  stats: {
    title: "Estadísticas",
    label: "Estadísticas de Invitados",
    total: "Total Invitados",
    confirmed: "Confirmados",
    pending: "Pendientes",
    declined: "Rechazados",
    responseRate: "Tasa de Respuesta"
  },
  empty: {
    noGuests: {
      title: "Sin Invitados",
      description: "Comienza añadiendo tu primer invitado."
    },
    noResults: {
      title: "Ningún invitado coincide con los filtros",
      description: "Modifica tus filtros para ver más resultados."
    }
  },
  groups: {
    family: "Familia",
    friends: "Amigos",
    colleagues: "Colegas",
    other: "Otro"
  },
  subtitle: "Gestiona tu lista de invitados y sus invitaciones",
  deleteGuest: "Eliminar invitado",
  guestDeleted: "Invitado eliminado exitosamente",
  guestCreated: "Invitado creado exitosamente",
  guestUpdated: "Invitado actualizado exitosamente",
  totalGuests: "{{count}} invitados",
  confirmed: "{{count}} confirmados",
  declined: "{{count}} rechazados",
  pending: "{{count}} pendientes",
  categories: {
    bride_groom: "Novios",
    family_close: "Familia cercana",
    family_extended: "Familia extendida",
    witness: "Padrino/Dama de honor",
    honor_party: "Cortejo",
    friend_close: "Amigo cercano",
    friend: "Amigo",
    colleague: "Colega",
    acquaintance: "Conocido",
    other: "Otro"
  },
  ageGroups: {
    child: "Niño",
    teen: "Adolescente",
    adult: "Adulto",
    senior: "Mayor"
  },
  export: {
    title: "Exportar invitados",
    description: "Exporte su lista de invitados a CSV",
    button: "Exportar",
    success: "Lista de invitados exportada con éxito"
  },
  tableAssigned: "Mesa {{number}}",
  unnamed: "Sin nombre",
  categoryOptions: {
    bride_groom: "Novios",
    family_close: "Familia cercana",
    family_extended: "Familia extendida",
    witness: "Padrino/Dama de honor",
    honor_party: "Cortejo",
    friend_close: "Amigo cercano",
    friend: "Amigo",
    colleague: "Colega",
    acquaintance: "Conocido",
    other: "Otro"
  },
  ageGroupOptions: {
    child: "Niño",
    teen: "Adolescente",
    adult: "Adulto",
    senior: "Mayor",
    ageRange: {
      adult: "(18-64 años)",
      senior: "(65+ años)"
    }
  },
  vip: "VIP",
  analytics: {
    title: "Estadísticas de invitados",
    totalGuests: "Total de invitados",
    confirmationRate: "Tasa de confirmación",
    adultsVsMinors: "Adultos vs Menores",
    rsvpStatus: "Estado RSVP",
    demographics: "Demografía",
    guestTypes: "Desglose de invitados"
  },
  settings: {
    rsvpSettings: "Configuración RSVP"
  }
};
